import React, { Component } from 'react';


class ContactForm extends Component {


    state = {
        name: '',
        email: '',
        subject: '',
        lastname: '',
        events: '',
        notes: '',
        error: {},
        submissionStatus: null,
        submissionMessage: '',
    }


    changeHandler = (e) => {
        const error = { ...this.state.error };
        error[e.target.name] = '';

        this.setState({
            [e.target.name]: e.target.value,
            error,
            submissionStatus: null,
            submissionMessage: '',
        })
    }

    submitHandler = async (e) => {
        e.preventDefault();

        const { name, email, subject, lastname, notes } = this.state;
        const error = {};

        if (!name) error.name = "Please enter your name";
        if (!email) error.email = "Please enter your email";
        if (!subject) error.subject = "Please enter your subject";
        if (!lastname) error.lastname = "Please enter your lastname";
        if (!notes) error.notes = "Please enter your message";

        this.setState({ error });

        if (Object.keys(error).length > 0) {
             this.setState({ submissionStatus: 'error', submissionMessage: 'Please fill out all required fields.' });
             return;
        }

         this.setState({ submissionStatus: 'submitting', submissionMessage: 'Sending message...' });

        const formData = new FormData();
        formData.append("access_key", "6b2a649f-9b96-4347-ad68-c5ce21937896");
        formData.append("subject", subject);
        formData.append("name", name);
        formData.append("lastname", lastname);
        formData.append("email", "info@thedarulquran.com");
        formData.append("message", notes);

        try {
            const response = await fetch("https://api.web3forms.com/submit", {
                method: "POST",
                body: formData,
                headers: {
                    Accept: "application/json"
                }
            });

            const result = await response.json();

            if (result.success) {
                 this.setState({
                    submissionStatus: 'success',
                    submissionMessage: 'Your message was sent successfully!',
                    name: '',
                    email: '',
                    subject: '',
                    lastname: '',
                    events: '',
                    notes: '',
                    error: {}
                });
            } else {
                 this.setState({
                    submissionStatus: 'error',
                    submissionMessage: result.message || 'An error occurred during submission.',
                });
            }
        } catch (err) {
             this.setState({
                submissionStatus: 'error',
                submissionMessage: 'An error occurred while sending the message.',
            });
        }
    }

    render(){
        const { name, email, subject, lastname, notes, error, submissionStatus, submissionMessage } = this.state;

        return(
            <form onSubmit={this.submitHandler} className="form">
                <div className="row">
                    <div className="col-lg-6 col-md-12">
                        <div className="form-field">
                            <input value={name} onChange={this.changeHandler} type="text" name="name" placeholder="Name" required/>
                            <p className="error-message">{error.name || ''}</p>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                        <div className="form-field">
                            <input value={lastname} onChange={this.changeHandler} type="text" name="lastname" placeholder="Lastname" required/>
                            <p className="error-message">{error.lastname || ''}</p>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="form-field">
                            <input onChange={this.changeHandler} value={email} type="email" name="email" placeholder="Email" required/>
                            <p className="error-message">{error.email || ''}</p>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="form-field">
                            <input onChange={this.changeHandler} value={subject} type="text" name="subject" placeholder="Subject" required/>
                            <p className="error-message">{error.subject || ''}</p>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="form-field">
                            <textarea name="notes" value={notes} onChange={this.changeHandler} placeholder="Message" required></textarea>
                            <p className="error-message">{error.notes || ''}</p>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="form-submit">
                            <button type="submit" className="theme-btn">Send Message</button>
                        </div>
                    </div>
                     {submissionStatus && (
                        <div className={`submission-notification ${submissionStatus}`}>
                            {submissionStatus === 'submitting' ? (
                                <>Sending...</>
                            ) : (
                                submissionMessage
                            )}
                        </div>
                    )}
                </div>
            </form>
        )
    }

}
export default  ContactForm;